@if (category$ | async; as category) {
<!-- category with subcategories -->
@if (!forceProductListing && category.hasChildren) {
<ish-category-categories [category]="category" [deviceType]="deviceType$ | async" />
} @else { @if (forceProductListing || category.hasOnlineProducts) {
<ish-category-products [category]="category" [deviceType]="deviceType$ | async" />
} }
<!-- category with products -->
<!-- empty category without subcategories and without products -->
@if (!category.hasChildren && !category.hasOnlineProducts) {
<!-- TODO: decide how to handle empty categories -->
<h1>{{ category.name }}</h1>
} }
